import { NgModule } from '@angular/core';
import {FreeDeliveryProgressComponent} from "../../components/free-delivery-progress/free-delivery-progress.component";
import {CartAddonsComponent} from "../../components/cart-addons/cart-addons.component";
import { CommonModule } from '@angular/common';
import {CartComponent} from "./cart.component";
import {AppRoutingModule} from "../../app-routing.module";
import {TextModule} from "../../components/text/text.module";
import {CardModule} from "../../components/card/card.module";
import {ButtonModule} from "../../components/button/button.module";
import {TextInputModule} from "../../components/text-input/text-input.module";
import {CartService} from "./service/cart.service";
import {PrimaryButtonComponent} from "../../components/button/primary/primary.button.component";
import {TopProductsModule} from "../../components/top-products/top-products.module";



@NgModule({
  declarations: [CartComponent],
    imports: [
        FreeDeliveryProgressComponent,
        CartAddonsComponent,
        CommonModule,
        AppRoutingModule,
        TextModule,
        CardModule,
        ButtonModule,
        TextInputModule,
        PrimaryButtonComponent,
        TopProductsModule
    ],
  providers: [CartService]
})
export class CartModule { }
